import { signal } from "@preact/signals-react";

const mensagemErro = signal(null);

export default mensagemErro;